import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getQuestionTypes } from '../utils/urls';

import { QuestionTypesResult } from '../types/questions';
import { ErrorModal } from 'types/modalTypes';

async function fetchQuestionTypes(): Promise<APIResult> {
  const response = await fetch(getQuestionTypes, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<QuestionTypesResult>;
};

type ResultItem = {
  id: number;
  name: string;
  description: string;
  IsQuestionAssociable: boolean;
};

type TResult = Array<ResultItem>;

function useGetQuestionTypes(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_question_types',
    async () => {
      const fetchResponse = await fetchQuestionTypes();
      const result = fetchResponse.Data.map(item => ({
        id: item.Id,
        name: item.Description,
        description: item.Verbose,
        IsQuestionAssociable: item.IsQuestionAssociable,
      }));

      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetQuestionTypes };
